import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        "fill-rule": "nonzero",
        d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 23.077C5.892 23.077.923 18.107.923 12S5.893.923 12 .923 23.077 5.893 23.077 12 18.107 23.077 12 23.077"
      }),
      _createElementVNode("path", { d: "M17.77 11.538h-5.308V6.462a.461.461 0 1 0-.924 0v5.076H6.231a.461.461 0 1 0 0 .924h5.307V18a.461.461 0 1 0 .924 0v-5.538h5.307a.461.461 0 1 0 0-.924" })
    ], -1)
  ]))]))
}
export default { render: render }